import { styled } from 'styled-components';
import {
  textExtraTinyNormal,
  textMediumSemiBold,
  textTinySemiBold,
} from '../../../Typography';

export const Container = styled.li`
  background: var(--black-300);
  display: flex;
  flex-direction: column;

  border-radius: var(--border-radius-default);
  border: 1px solid var(--border-color-default);
  color: var(--text-standard-secondary);

  .cardHeader {
    display: flex;
    height: 32px;
    border-radius: var(--border-radius-default) var(--border-radius-default) 0 0;
    border-bottom: 1px solid var(--border-color-default);
    background: var(--black-200);
  }

  button[aria-label="Actions"] {
    margin: 0 var(--space-100) 0 var(--space-50);
    align-self: center;
  }

  .cardBody {
    padding: var(--space-200);
    color: var(--text-standard-secondary);

    p {
      margin: 0;
    }
  }

  .severity {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 var(--space-100);
    border-right: 1px solid var(--border-color-default);
    margin-right: auto;
    svg path {
      fill: var(--text-destructive);
    }
  }

  .timeStamp {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--space-100) 0;
    ${textExtraTinyNormal};
  }

  .title{
    ${textMediumSemiBold};
    margin-bottom: var(--space-150);
  }

  p.rootCauseCaption {
    color: var(--text-subtle);
    ${textTinySemiBold};
    margin-top: var(--space-300);
  }

  p.entity {
    display: flex;
    gap: var(--space-100);
    margin-top: var(--space-150);
    ${textTinySemiBold};
  }

  p.sourceEntity {
    display: flex;
    gap: var(--space-100);
    margin-top: var(--space-100);
    ${textTinySemiBold};
  }

  .cardFooter {
    display: flex;
    justify-content: end;
    padding: var(--space-150) var(--space-200);
    border-top: 1px solid var(--border-color-default);
  }

  &.emptyStateCard {
    background: none;
    border: none;

    .cardBody {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0;

      gap: var(--space-200);
      ${textMediumSemiBold};
    }

    a {
      color: var(--black-900);
      text-decoration: none;
      &:hover {
        text-decoration: underline;
    }
  }
`;
